import Sentry from 'Integrations/Sentry';

const setErrorDetails = (eventData, eventResource) => {
  // Not all yodlee errors provide us with much detail.
  // If we get a yodlee error without a lot of detail, let's add more info to it
  if (!eventResource.attr('status')) {
    eventResource.attr('status', 'FAILED');
  }
  if (!eventResource.attr('additionalStatus')) {
    eventResource.attr('additionalStatus', eventData.title);
  }
  if (!('reason' in eventData) && 'code' in eventData && 'message' in eventData) {
    eventResource.attr('reason', `${eventData.code}: ${eventData.message}`);
  }
  return eventResource;
};

export const sendEvent = async (eventCollection, sessionId, eventData, eventType) => {
  if (!eventCollection) {
    if (eventType === 'ERROR') {
      Sentry.createSentryErrorLog(new Error(`Yodlee error without any event collection: ${JSON.stringify(eventData)}`));
    }
    return;
  }

  try {
    const eventResource = eventCollection.create();
    eventResource.attributes(eventData);
    eventResource.attr('eventType', eventType);
    eventResource.attr('sessionId', sessionId);
    if (eventType === 'ERROR') {
      setErrorDetails(eventData, eventResource);
    }
    await eventResource.submit();
  } catch (err) {
    Sentry.createSentryErrorLog(err);
  }
};
